<template>
  <v-card
    ref="extra_info"
    v-if="visible"
    id="extra_info"
    elevation="0"
    class="mx-auto secondary rounded-0"
  >
    <CardHeader
      title="6. YDERLIGERE?"
      :icon="!displayExtraInfo ? openDisplayIcon : closeDisplayIcon"
      @iconClicked="displayExtraInfo = !displayExtraInfo"
    />
    <div
      v-if="displayExtraInfo"
      :class="this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'pt-4 pb-2 px-7'"
    >
      <v-row no-gutters v-if="referencesVisible" class="pt-2">
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 4" class="px-2">
          <v-text-field
            ref="reference_1"
            v-model="reference_1"
            label="Reference"
            :required="!allowEmptyReference1"
            :rules="!allowEmptyReference1 ? reference1Rules : []"
            outlined
            dense
            color="primary"
            background-color="white"
          >
            <v-tooltip bottom slot="append-outer" color="info">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="info" style="pointer-events: auto;">
                  {{ helpIcon }}
                </v-icon>
              </template>
              <span>
                {{ reference1HelpText }}
              </span>
            </v-tooltip>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 8" class="px-2">
          <v-textarea
            v-model="remark"
            label="Bemærkninger"
            auto-grow
            rows="1"
            clearable
            outlined
            dense
            color="primary"
            background-color="white"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="booker_email">
        <v-col cols="12" class="px-2">
          <v-checkbox
            v-model="notification_to_booker"
            :label="notification_to_booker_label"
            color="primary"
            ripple
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="px-2">
          <v-row no-gutters>
            <v-checkbox
              v-model="photo_documentation"
              label="Fotodokumentation"
              color="primary"
              ripple
            >
              <v-tooltip bottom slot="append" color="info">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="info" style="pointer-events: auto;">
                    {{ helpIcon }}
                  </v-icon>
                </template>
                <span>
                  {{ photoDocumentationHelpText }}
                </span>
              </v-tooltip>
            </v-checkbox>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="px-2">
          <v-checkbox
            v-model="allow_no_signature"
            label="Må stilles uden underskrift"
            color="primary"
            ripple
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 5 : 2" class="px-2">
          <v-checkbox v-model="insurance" label="Forsikring"></v-checkbox>
        </v-col>
        <v-col
          :cols="this.$vuetify.breakpoint.smAndDown ? 6 : 2"
          class="px-2 pt-1"
        >
          <v-text-field
            v-model="insurance_amount"
            label="Forsikret beløb"
            placeholder="0,00"
            suffix="DKK"
            :rules="insurance ? insuranceAmountRules : []"
            :required="insurance"
            :disabled="!insurance"
            @blur="updateInsuranceAmount"
            outlined
            dense
            color="primary"
            background-color="white"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { tools } from "../helpers";
import { dictionary } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "ExtraInfo",
  components: { CardHeader },
  created() {
    this.referencesVisible = !this.$store.getters["user/hideBookingReferences"];
    this.remarksVisible = !this.$store.getters["user/hideBookingRemarks"];
    this.notificationsVisible = !this.$store.getters[
      "user/hideBookingNotifications"
    ];
    this.insuranceVisible = !this.$store.getters["user/hideBookingInsurance"];
    this.allowEmptyReference1 = this.$store.getters[
      "user/allowEmptyReference1"
    ];
  },
  data: () => ({
    // displayExtraInfo: false,
    openDisplayIcon: dictionary.mdi.open,
    closeDisplayIcon: dictionary.mdi.close,
    referencesVisible: true,
    allowEmptyReference1: true,
    reference1Rules: [v => !!v || false],
    remarksVisible: true,
    notificationsVisible: true,
    emailRules: [
      v =>
        (!!v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
        "Indtast korrekt e-mail"
    ],
    insuranceVisible: true,
    insuranceAmountRules: [
      v => {
        if (!!v && !isNaN(parseFloat(v)) && tools.parseDouble(v) > 0)
          return true;
        return false;
      }
    ],
    helpIcon: dictionary.mdi.help,
    reference1HelpText: dictionary.help.reference_1,
    photoDocumentationHelpText: dictionary.help.photo_documentation
  }),
  computed: {
    visible: {
      get() {
        return (
          this.$store.state.booking.data.account &&
          this.$store.state.booking.data.pickup.address.address &&
          this.$store.state.booking.data.pickup.address.name &&
          this.$store.state.booking.data.delivery.address.address &&
          this.$store.state.booking.data.delivery.address.name &&
          this.$store.state.booking.data.pickup.timewindow.from.date &&
          this.$store.state.booking.data.pickup.timewindow.from.time &&
          this.$store.state.booking.data.pickup.timewindow.to.date &&
          this.$store.state.booking.data.pickup.timewindow.to.time &&
          this.$store.state.booking.data.delivery.timewindow.from.date &&
          this.$store.state.booking.data.delivery.timewindow.from.time &&
          this.$store.state.booking.data.delivery.timewindow.to.date &&
          this.$store.state.booking.data.delivery.timewindow.to.time &&
          this.goodsValid() &&
          this.$store.state.booking.data.vehicle_type.external_key
        );
      }
    },
    displayExtraInfo: {
      get() {
        return this.$store.state.booking.display_extra_info;
      },
      set(value) {
        this.$store.state.booking.display_extra_info = value;
      }
    },
    reference_1: {
      get() {
        return this.$store.state.booking.data.reference_1;
      },
      set(value) {
        this.$store.state.booking.data.reference_1 = value;
      }
    },
    reference_2: {
      get() {
        return this.$store.state.booking.data.reference_2;
      },
      set(value) {
        this.$store.state.booking.data.reference_2 = value;
      }
    },
    remark: {
      get() {
        return this.$store.state.booking.data.remark;
      },
      set(value) {
        this.$store.state.booking.data.remark = value;
      }
    },
    notification_to_booker: {
      get() {
        return this.$store.state.booking.data.notification
          .notification_to_booker;
      },
      set(value) {
        this.$store.commit("booking/updateNotificationToBooker", value);
      }
    },
    booker_email: {
      get() {
        return this.$store.state.booking.data.notification.booker_email;
      },
      set(value) {
        this.$store.state.booking.data.notification.booker_email = value;
      }
    },
    notification_to_booker_label: {
      get() {
        return (
          "Notifikation til booker (" +
          this.$store.state.booking.data.notification.booker_email +
          ")"
        );
      }
    },
    photo_documentation: {
      get() {
        return this.$store.state.booking.data.photo_documentation;
      },
      set(value) {
        this.$store.state.booking.data.photo_documentation = value;
      }
    },
    allow_no_signature: {
      get() {
        return this.$store.state.booking.data.allow_no_signature;
      },
      set(value) {
        this.$store.state.booking.data.allow_no_signature = value;
      }
    },
    // booker_notification_types: {
    //     get() {
    //         return this.$store.state.booking.data.notification.booker_notification_types;
    //     },
    //     set(value) {
    //         this.$store.state.booking.data.notification.booker_notification_types = value;
    //     },
    // },
    // notification_to_alt: {
    //     get() {
    //         return this.$store.state.booking.data.notification.notification_to_alt;
    //     },
    //     set(value) {
    //         this.$store.commit('booking/updateNotificationToAlt', value );
    //     },
    // },
    // alt_email: {
    //     get() {
    //         return this.$store.state.booking.data.notification.alt_email;
    //     },
    //     set(value) {
    //         this.$store.state.booking.data.notification.alt_email = value;
    //     },
    // },
    // alt_notification_types: {
    //     get() {
    //         return this.$store.state.booking.data.notification.alt_notification_types;
    //     },
    //     set(value) {
    //         this.$store.state.booking.data.notification.alt_notification_types = value;
    //     },
    // },
    insurance: {
      get() {
        return this.$store.state.booking.data.insurance;
      },
      set(value) {
        this.$store.state.booking.data.insurance = value;
        if (!this.$store.state.booking.data.insurance) {
          this.$store.state.booking.data.insurance_amount = "0,00";
        }
        this.calculatePrice();
      }
    },
    insurance_amount: {
      get() {
        return this.$store.state.booking.data.insurance_amount;
      },
      set(value) {
        this.$store.state.booking.data.insurance_amount = value;
      }
    }
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs.extra_info);
          });

          if (!this.allowEmptyReference1 && !this.reference_1) {
            this.$nextTick(() => {
              this.$refs.reference_1.focus();
            });
          }
        }
      }
    }
  },
  methods: {
    goodsValid() {
      return (
        this.$store.state.booking.data.goods &&
        this.$store.state.booking.data.goods[0] &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].cll) > 0 &&
        this.$store.state.booking.data.goods[0].description.length > 0 &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].weight) > 0
      );
    },
    updateInsuranceAmount() {
      this.$store.state.booking.data.insurance_amount = tools.parseDoubleToString(
        tools.parseDouble(this.$store.state.booking.data.insurance_amount)
      );
      this.calculatePrice();
    },
    async calculatePrice() {
      await this.$store.dispatch("booking/calculatePrice");
    }
  }
};
</script>
